<template>
	<div>
		<DropdownStatus
			v-model="currentLng"
			:options="props.languages"
			optionLabel="title"
			optionValue="identifier"
			@change="switchLanguage"
			placeholder="'Select Language'"
			class="w-full shadow-none border h-full items-center"
		>
			<template #value>
				<div class="flex items-center text-md">
					<span :class="`fi fi-${flagCode(selectedLanguage?.identifier)}`"></span>
					<div class="ml-2" v-if="!props.hideLabel">{{ selectedLanguage?.title }}</div>
				</div>
			</template>

			<template #option="slotProps">
				<div class="flex items-center text-md">
					<span :class="`fi fi-${flagCode(slotProps.option.identifier)}`"></span>
					<div class="ml-2" v-if="!props.hideLabel">{{ slotProps.option.title }}</div>
				</div>
			</template>
		</DropdownStatus>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { LanguageItem } from '@/types';
import { useAppStore } from '@/stores/app-store';

const { currentLng } = useAppStore();
const emit = defineEmits<{ changeLanguage: [string] }>();


const props = withDefaults( defineProps<{
	languages: LanguageItem[];
	hideLabel?: boolean;
	hideHeader?: boolean;

}>(), {
	hideLabel: false,
	hideHeader: true,
} )




const selectedLanguage = computed(() =>
	props.languages.find((item) => item.identifier === currentLng.value)
);


const flagCode = (code?: string) => {
	if (!code) return 'xx';
	if (code === 'sq') return 'al';
	if (code === 'en') return 'gb';
	return code;
};

const switchLanguage = () => {
	if (selectedLanguage.value) {
		emit('changeLanguage', selectedLanguage.value.identifier);
	}
};
</script>